import React from "react";
import { DraggableProvided } from "react-beautiful-dnd";
import Card from "../../../../componentLibrary/Card";
import Input from "../../../../componentLibrary/Input";
import { ComponentI, DateTimeTypeEnum } from "../../../../types";
import Combobox from "../../../../componentLibrary/Combobox";
import { CopyVariableButton } from "../../utils/CopyVariableButton";

export default function DateTimeContentCard({
  component,
  handleContentChange,
  provided,
}: {
  component: ComponentI;
  handleContentChange: (
    id: string,
    field: string,
    value: string | boolean,
  ) => void;
  provided: DraggableProvided;
}) {
  return (
    <Card>
      <Input
        label="Label"
        value={component.content.label}
        onChange={(e) =>
          handleContentChange(component._id, "label", e.target.value)
        }
        placeholder="Enter the label for the date time component"
        required
        className="mb-2"
      />
      <div
        className="space-y-2 mb-2"
        data-rbd-drag-handle-context-id={
          provided.dragHandleProps?.["data-rbd-drag-handle-context-id"]
        }
        data-rbd-drag-handle-draggable-id="gibberish"
      >
        <div className="text-md font-semibold">Type</div>
        <Combobox
          options={Object.values(DateTimeTypeEnum).map((type) => ({
            label: type,
            value: type,
          }))}
          value={{
            label: component.content.type,
            value: component.content.type,
          }}
          onChange={(option) =>
            handleContentChange(component._id, "type", option.value)
          }
        />
      </div>
      <Input
        label="Variable Name"
        value={component.content.variable}
        onChange={(e) =>
          handleContentChange(component._id, "variable", e.target.value)
        }
        placeholder="reminder_date"
        required
        TopRightElement={
          <CopyVariableButton type="icon" component={component} />
        }
        className="mb-2"
      />
    </Card>
  );
}
